import {
  buildGiftCode,
  getCustomerServiceInfo,
  getUserList,
  getUserStatistics,
  getCardInfo,
  getDesignDetailsList,
  getFilePhasesType
} from '@/api/serviceSystem'

const state = {
}

const mutations = {
}

const actions = {
  // d-05-(rad2)空间需求评估列表
  buildGiftCode({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      buildGiftCode(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // d-05-(rad2)空间需求评估列表
  getCustomerServiceInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getCustomerServiceInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // SC-01-门店用户统计
  async getUserStatistics({ state, commit }, data) {
    try {
      const res = await getUserStatistics(data)
      return res.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // SC-02-门店用户列表
  async getUserList({ state, commit }, data) {
    try {
      const res = await getUserList(data)
      console.log(res)
      return res.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async getCardInfo({ state, commit }, data) {
    try {
      const res = await getCardInfo(data)
      return res.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // R00-获取设计方案的明细列表
  async getDesignDetailsList({ state, commit }, data) {
    try {
      const res = await getDesignDetailsList(data)
      return res.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // 阶段判断
  async getFilePhasesType({ state, commit }, data) {
    try {
      const res = await getFilePhasesType(data)
      return res.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
